import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../../../../store';
import { RecommendationProps } from '../service/recommendations.interface';

interface State {
    current: RecommendationProps | null;
}

const initialState: State = {
    current: null,
};

export const recommendationAISlice = createSlice({
    name: 'recommendationAISelector',
    initialState,
    reducers: {
        resetCurrentRecommendation: () => initialState,
        setCurrentRecommendation: (
            state,
            action: PayloadAction<RecommendationProps | null>
        ) => {
            state.current = action.payload;
        },
    },
});

export const { setCurrentRecommendation, resetCurrentRecommendation } =
    recommendationAISlice.actions;

export const selectCurrentRecommendation = (state: RootState) =>
    state.recommendationAISelector.current;

export const recommendationAIReducer = recommendationAISlice.reducer;
